import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function updateAssetSubCategoryService(token,data) {
    return axios.post(`${CURRENT_API_URL}/assetgallery/updateAssetSubCategory`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while moving asset. please try again.");
        return false;
    });
}

export default updateAssetSubCategoryService;